exports.getServiceListApiEndPoint = '/bx_block_categories/services';
exports.importCsv = "Import";
exports.exportCsv = "Export";
exports.exportTemplate = "Export Template";
exports.buttonImportExport = "Export/Import";
exports.importCSV = "Import";
exports.exportCSV = "Export";
exports.updateOutFileApi = "bx_block_cfmetalprogettisolutionintegration2/metalprogetti_solution_integrations/update_out_files";
